import { AxiosResponse } from 'axios';
import { UploadState } from '../SetupInfoPanelAnaliseDeCobertura/@types';
import { AderenciaTableData } from './types';

export const filterPendingAderencia = (data: AderenciaTableData[]): AderenciaTableData[] => data.filter(item => item.pendente === true);

export const setModalUploadStatus = (resp: AxiosResponse, set: (name: string, data: any) => void) => {
  if (resp.status === 400) {
    // Erro, ARQUIVO INVALIDO
    set('uploadState', UploadState.WRONG_FILE);
  }

  if (resp.status === 207 && resp.data.todosInvalidos) {
    // Erro, GTIN totalmente INVALIDO
    set('uploadState', UploadState.ERROR);
  }

  if (resp.status === 207 && !resp.data.todosInvalidos) {
    // Erro, GTIN parcialmente INVALIDO
    set('uploadState', UploadState.PARCIAL);
  }

  if (resp.status === 200) {
    set('openModalAderenciaProductUpload', false);
    set('uploadState', UploadState.SUCCESS);
  }

  if (resp.status === 422 && resp.data === 'LIMITE_GTINS_EXCEDIDO') {
    // Limite de GTIN EXCEDIDO
    set('uploadState', UploadState.EXCEED);
  }
};
